import React from "react";
import { Link } from "react-router-dom";

const base =
  "group relative inline-flex items-center justify-center gap-2.5 rounded-full font-medium tracking-wide transition-all duration-300 ease-standard disabled:cursor-not-allowed disabled:opacity-50";

const sizes = {
  sm: "px-5 py-2 text-[13px]",
  md: "px-7 py-3 text-sm",
  lg: "px-9 py-4 text-base",
};

const variants = {
  primary:
    "bg-azure text-paper shadow-md hover:bg-electric hover:shadow-glow-electric dark:bg-electric dark:text-paper dark:hover:bg-electric-hover",
  electric:
    "bg-electric text-paper shadow-md hover:bg-electric-hover hover:shadow-glow-electric",
  outline:
    "border border-[var(--color-border-strong)] text-ink hover:border-azure hover:bg-azure hover:text-paper hover:shadow-md dark:text-slightwhite dark:hover:border-electric dark:hover:bg-electric dark:hover:text-paper",
  ghost:
    "text-ink hover:text-azure dark:text-slightwhite dark:hover:text-electric px-0",
  light:
    "bg-paper text-azure shadow-sm hover:bg-paper-warm hover:shadow-lg",
};

const Arrow = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="transition-transform duration-300 ease-standard group-hover:translate-x-1"
    aria-hidden="true"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const Button = ({
  children,
  to,
  href,
  variant = "primary",
  size = "md",
  withArrow = false,
  className = "",
  ...rest
}) => {
  const classes = `${base} ${sizes[size] || sizes.md} ${
    variants[variant] || variants.primary
  } ${className}`;

  const content = (
    <>
      {children}
      {withArrow && <Arrow />}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        className={classes}
        target={href.startsWith("http") ? "_blank" : undefined}
        rel={href.startsWith("http") ? "noreferrer" : undefined}
        {...rest}
      >
        {content}
      </a>
    );
  }

  return (
    <button className={classes} {...rest}>
      {content}
    </button>
  );
};

export default Button;
